export const CURRENCY_FALLBACKS = {
  AED: 'Ð',
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£'
};

export const formatCurrency = (amount, currencyCode, currencySymbol) => {
  const code = currencyCode || currencySymbol || 'AED';
  let symbol = currencySymbol || code;

  if (CURRENCY_FALLBACKS[code]) {
    symbol = CURRENCY_FALLBACKS[code];
  } else if (CURRENCY_FALLBACKS[symbol]) {
    symbol = CURRENCY_FALLBACKS[symbol];
  }

  return `${symbol} ${Number(amount || 0).toFixed(2)}`;
};
